// UI strings for the Voice → Booking feature. Assistant/booking data comes
// localized from the backend; these are the on-screen control labels.
const V = {
  de: {
    book: "Mit Sprache buchen",
    listening: "Ich höre zu … zum Stoppen tippen",
    processing: "Einen Moment …",
    mic_error: "Mikrofon nicht verfügbar. Bitte Zugriff erlauben.",
    not_understood: "Das habe ich nicht verstanden. Bitte erneut versuchen.",
    heard: "Verstanden",
    hint: 'z. B. „Morgen 9 Uhr vom Flughafen Zürich nach Luzern, 3 Personen"',
    speak: "Sprechen",
    confirm_title: "Ihre Sprachbuchung – bitte prüfen",
    pax_word: "Pers.",
    bags_word: "Gepäck",
    round: "Hin- & Rückfahrt",
    hours_word: "Std.",
  },
  en: {
    book: "Book by voice",
    listening: "Listening … tap to stop",
    processing: "One moment …",
    mic_error: "Microphone not available. Please allow access.",
    not_understood: "Sorry, I didn't catch that. Please try again.",
    heard: "Understood",
    hint: 'e.g. "Tomorrow 9am from Zurich Airport to Lucerne, 3 people"',
    speak: "Speak",
    confirm_title: "Your voice booking – please confirm",
    pax_word: "pax",
    bags_word: "bags",
    round: "Round trip",
    hours_word: "h",
  },
  fr: {
    book: "Réserver à la voix",
    listening: "J'écoute … appuyez pour arrêter",
    processing: "Un instant …",
    mic_error: "Micro indisponible. Veuillez autoriser l'accès.",
    not_understood: "Désolé, je n'ai pas compris. Réessayez.",
    heard: "Compris",
    hint: 'ex. « Demain 9h de l\'aéroport de Zurich à Lucerne, 3 personnes »',
    speak: "Parler",
  },
  it: {
    book: "Prenota a voce",
    listening: "Sto ascoltando … tocca per fermare",
    processing: "Un momento …",
    mic_error: "Microfono non disponibile. Consenti l'accesso.",
    not_understood: "Non ho capito. Riprova.",
    heard: "Capito",
    hint: 'es. "Domani alle 9 dall\'aeroporto di Zurigo a Lucerna, 3 persone"',
    speak: "Parla",
  },
  es: {
    book: "Reservar por voz",
    listening: "Escuchando … toca para parar",
    processing: "Un momento …",
    mic_error: "Micrófono no disponible. Permite el acceso.",
    not_understood: "No lo he entendido. Inténtalo de nuevo.",
    heard: "Entendido",
    hint: 'p. ej. "Mañana 9h del aeropuerto de Zúrich a Lucerna, 3 personas"',
    speak: "Hablar",
  },
  tr: {
    book: "Sesle rezervasyon",
    listening: "Dinliyorum … durdurmak için dokun",
    processing: "Bir saniye …",
    mic_error: "Mikrofon kullanılamıyor. Lütfen erişime izin verin.",
    not_understood: "Anlayamadım. Lütfen tekrar deneyin.",
    heard: "Anlaşıldı",
    hint: 'örn. "Yarın 9\'da Zürih havalimanından Luzern\'e, 3 kişi"',
    speak: "Konuş",
  },
  ar: {
    book: "الحجز بالصوت",
    listening: "أستمع … اضغط للإيقاف",
    processing: "لحظة من فضلك …",
    mic_error: "الميكروفون غير متاح. يرجى السماح بالوصول.",
    not_understood: "لم أفهم ذلك. يرجى المحاولة مرة أخرى.",
    heard: "فهمت",
    hint: 'مثال: "غدًا الساعة 9 من مطار زيورخ إلى لوتسرن، 3 أشخاص"',
    speak: "تحدّث",
  },
  fa: {
    book: "رزرو با صدا",
    listening: "در حال شنیدن … برای توقف بزنید",
    processing: "یک لحظه …",
    mic_error: "میکروفون در دسترس نیست. لطفاً دسترسی بدهید.",
    not_understood: "متوجه نشدم. دوباره تلاش کنید.",
    heard: "متوجه شدم",
    hint: 'مثال: «فردا ساعت ۹ از فرودگاه زوریخ به لوتسرن، ۳ نفر»',
    speak: "صحبت",
  },
  ckb: {
    book: "حجزکردن بە دەنگ",
    listening: "گوێ دەگرم … بۆ وەستان دەستبنێ",
    processing: "چرکەیەک …",
    mic_error: "مایکرۆفۆن بەردەست نییە. تکایە ڕێگە بدە.",
    not_understood: "تێنەگەیشتم. تکایە دووبارە هەوڵبدەرەوە.",
    heard: "تێگەیشتم",
    hint: 'نموونە: «سبەینێ کاتژمێر ٩ لە فڕۆکەخانەی زوریخ بۆ لوسێرن، ٣ کەس»',
    speak: "قسە بکە",
    confirm_title: "حجزەکەت بە دەنگ – تکایە پشتڕاستی بکەرەوە",
    pax_word: "کەس",
    bags_word: "بار",
    round: "چوون و هاتنەوە",
    hours_word: "کاتژمێر",
  },
};

export const voiceStr = (lang) => V[lang] || V.en;
